var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYacare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 13,
  height: 15
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 7.187V2.955c0-.34.261-.63.62-.691C2.702 1.914 4.574.874 5.505.287a1.864 1.864 0 0 1 1.991 0c.93.588 2.803 1.627 4.883 1.977.36.06.621.35.621.69v4.233c0 2.084-1.122 4.044-3.334 5.827A16.7 16.7 0 0 1 6.5 15C5.178 14.37 0 11.616 0 7.187"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#00AFAC"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#73CE00"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#008161"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#61B425"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#18A34D"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 1.5,
  d: "M2.786 7.5h7.429M6.5 3.75v7.5"
}))));
export default SvgIconYacare;